import { useEffect } from "react";
import { useOverlayFeature } from "./map/useOverlayFeature";
export const useResetOverlayFeatureOnLoad = () => {
    const [, setOverlayFeature] = useOverlayFeature();
    useEffect(() => {
        setOverlayFeature(undefined);
    }, []); // eslint-disable-line
};
